import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";

import {MiperfilComponent} from "./miperfil/miperfil.component";

import {UsuarioModule} from "../seguridad/usuario/usuario.module";
import {MaterialModule} from "../../../material.module";
import {LoadingModule} from "../../../autenticacion/loadingScreen/loading.module";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        UsuarioModule,
        MaterialModule,
        LoadingModule
    ],
    declarations: [MiperfilComponent]
})
export class PerfilModule {


}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/perfil/perfil.module.ts